import Select from "@imminently/decisively-ui/Select";
import React from "react";
import { useTranslation } from "react-i18next";
import { useGraphVisualisation } from "../../../hooks/useGraphVisualisation";
import type { GraphVizType } from "../../../providers/RuleGraphProvider";

interface GraphTypeSelectorProps {}

const GraphTypeSelector = (props: GraphTypeSelectorProps) => {
  const { t } = useTranslation();
  const { graphVizType, setGraphVizType, extraVizTypes, hasClassic, hasNebula, hasData, hasDecisionReport } =
    useGraphVisualisation();

  const selectType = (value: string | null) => {
    if (value) {
      setGraphVizType(value as GraphVizType);
    }
  };

  const options = React.useMemo(() => {
    const opts = [] as Array<{ value: string; label: string }>;
    if (hasClassic) {
      opts.push({
        value: "classic-beta",
        label: t("debugger.rule_graph"),
      });
    }
    if (hasNebula) {
      opts.push({
        value: "nebula",
        label: t("debugger.nebula"),
      });
    }
    if (hasData) {
      opts.push({
        value: "data",
        label: t("debugger.data"),
      });
    }
    if (hasDecisionReport) {
      opts.push({
        value: "decisionreport",
        label: t("debugger.decision_report"),
      });
    }
    if (extraVizTypes) {
      for (const extraVizType of extraVizTypes) {
        opts.push({
          value: extraVizType.id,
          label: t(extraVizType.nameTranslationKey),
        });
      }
    }
    return opts;
  }, [hasClassic, hasNebula, hasData, hasDecisionReport, extraVizTypes, t]);

  return (
    <Select
      value={graphVizType || null}
      options={options}
      onValueChange={selectType}
      placeholder={t("debugger.graph_type")}
      className="min-w-[10rem]"
    />
  );
};

export default GraphTypeSelector;
